<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import Loader from "../widgets/loader.vue";
import Multiselect from "vue-multiselect";
import VueTypeaheadBootstrap from "@/components/vueTypeAheadBootstrap/VueTypeaheadBootstrap";

// Custom Components
import PbxService from "@/helpers/APIService/pbx.service";
import TicketService from "@/helpers/APIService/ticket.service";
import SuperService from "@/helpers/APIService/super.service";
import MediaService from "@/helpers/APIService/media.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed, authMethods } from "@/state/helpers";

export default {
  data() {
    return {
      pbx_serve_form: {
        domain_uuid: "",
        caller_name: "",
        caller_email: "",
        caller_number: "",
        is_email_notification: true,
        ticket_title: "",
        priority: "",
        assign_to_user_uuid: "",
        description: "",
        attached_file: "",
      },
      domain_name: "",
      priorityOptions: [
        {
          text: "High",
          value: "high",
        },
        {
          text: "Urgent",
          value: "urgent",
        },
        {
          text: "Normal",
          value: "normal",
        },
      ],
      assignedToOptions: [],
      domainListOptions: [],
      titleData: [],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      isLoadingEdit: false,
      fileObject: null,
      mediaUrl: "",
      waitingURL: "",
    };
  },
  props: {
    ticketId: String,
    domainId: String,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    pbx_serve_form: {
      domain_uuid: { required },
      ticket_title: { required },
      priority: { required },
      assign_to_user_uuid: { required },
      description: { required },
      caller_email: { email },
      caller_number: {
        minLength: minLength(10),
      },
    },
  },
  components: {
    Loader,
    Multiselect,
    VueTypeaheadBootstrap,
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.setValue();
    this.getUserList();
  },
  methods: {
    ...authMethods,
    // Method is used to set value
    setValue() {
      // Get domain list
      if (localStorage.domain_list) {
        const domainList = JSON.parse(
          atob(localStorage.getItem("domain_list"))
        );
        domainList.forEach((item) => {
          this.domainListOptions.push({
            value: item.domain_uuid,
            text: item.domain_name,
          });
        });
      } else {
        PbxService.getDomainList().then((res) => {
          if (res != "") {
            res.forEach((item) => {
              this.domainListOptions.push({
                value: item.domain_uuid,
                text: item.domain_name,
                item,
              });
            });
          }
        });
      }
      TicketService.getTicketTitleList()
        .then((res) => {
          if (res.result) {
            this.titleData = res.result;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });

      if (this.isEdit == true) {
        this.isLoadingEdit = false;
        TicketService.getTicketDetail(this.ticketId, this.domainId)
          .then((response) => {
            if (response.status == false) {
              return Middleware.notification(response.message);
            }
            if (response.result) {
              this.pbx_serve_form = {
                ...response.result,
              };
              this.pbx_serve_form.domain_uuid = this.domainListOptions.filter(
                (val) => val.value == response.result.domain_uuid
              );
              this.pbx_serve_form.priority = this.priorityOptions.filter(
                (val) => val.value == response.result.priority
              );
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is used to get user list
    async getUserList() {
      try {
        const supportUser = await SuperService.getCdxUserList();
        const hotelUser = await SuperService.getHotelUserList();
        supportUser.map((user) => {
          this.assignedToOptions.push({
            text: `${user.first_name ? user.first_name : ""}  ${
              user.last_name ? user.last_name : ""
            } (Support Staff)`,
            value: user.id,
            user: user,
            user_type: "support_staff",
          });
        });
        hotelUser.map((user) => {
          this.assignedToOptions.push({
            text: `${user.first_name ? user.first_name : ""}  ${
              user.last_name ? user.last_name : ""
            } (Hotel Admin)`,
            value: user.id,
            user: user,
            user_type: "hotel_user",
          });
        });
        this.pbx_serve_form.assign_to_user_uuid = {
          text: `${
            this.user.user.first_name ? this.user.user.first_name : ""
          }  ${
            this.user.user.last_name ? this.user.user.last_name : ""
          } (Hotel Admin)`,
          value: this.user.user.id,
          user: this.user.user,
          user_type: "hotel_user",
        };
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to handle submit of form
    async onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const domain_id = this.pbx_serve_form.domain_uuid.value;
        this.pbx_serve_form.priority = this.pbx_serve_form.priority.value;
        const data = {
          ...this.pbx_serve_form,
          assign_to_user_uuid: this.pbx_serve_form.assign_to_user_uuid.value,
          assign_to_user_name: this.pbx_serve_form.assign_to_user_uuid.user
            ? this.pbx_serve_form.assign_to_user_uuid.user.first_name
            : "" + " " + this.pbx_serve_form.assign_to_user_uuid.user
            ? this.pbx_serve_form.assign_to_user_uuid.user.last_name
            : "",
        };
        if (data.attached_file == "") {
          delete data.attached_file;
        }
        delete data.domain_uuid;
        if (this.isEdit) {
          TicketService.updateTicketDetail(this.ticketId, data, domain_id)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              Middleware.notification("Successfully updated !!", "success");
              this.$emit("submitted", response.result);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          let fileUrl;
          if (this.fileObject != null) {
            this.fileObject.name.replaceAll(" ", "_");
            let new_media_url = "";
            let extensions = [
              "jpg",
              "png",
              "jpeg",
              "webp",
              "heic",
              "heif",
              "bmp",
            ];
            extensions.forEach((element) => {
              if (this.fileObject.name.includes(element)) {
                let pattern = new RegExp(`\\.${element}.*`);
                new_media_url = this.fileObject.name.replace(
                  pattern,
                  `_${this.randomString(5)}.${element}`
                );
              }
            });
            await MediaService.mediaFileUrlGenerate({
              file_name: `ticket_${new_media_url}`,
              file_location: this.domain_name + "/support-ticket",
            })
              .then((response) => {
                fileUrl = response.result;
                this.waitingURL = response.result;
                MediaService.mediaFileUpload(fileUrl, this.mediaUrl).then(
                  () => {
                    fileUrl = "";
                    let fillerUrl = this.waitingURL;
                    if (fillerUrl != null && fillerUrl != "") {
                      this.waitingURL = fillerUrl.split("?")[0];
                    } else {
                      return Middleware.notification(
                        "File type is not suppoerted !!",
                        "danger"
                      );
                    }
                  }
                );
              })
              .catch((error) => {
                errorHandler(error);
              });
          }

          TicketService.createTicket(
            { ...data, status: "new", attached_file: this.waitingURL },
            domain_id
          )
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              Middleware.notification("Successfully added !!", "success");
              this.$emit("submitted", response.result);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is used to generate random string
    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    // Method is used to handle upload file
    uploadFile(event) {
      this.mediaUrl = event.target.files[0];
      this.fileObject = this.mediaUrl;
    },
    handleDomainChange() {
      this.pbx_serve_form.domain_uuid.text
        ? (this.domain_name = this.pbx_serve_form.domain_uuid.text)
        : (this.domain_name = "");
      this.pbx_serve_form.domain_uuid.item
        ? this.pbx_serve_form.domain_uuid.item.hotel_name
          ? (this.pbx_serve_form.hotel_name =
              this.pbx_serve_form.domain_uuid.item.hotel_name)
          : (this.pbx_serve_form.hotel_name = "")
        : "";
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    // Method is used to handle title change
    handleHit(trackBy, data = null) {
      if (data !== null) {
        this.pbx_serve_form.ticket_title = data[trackBy];
        this.pbx_serve_form.priority = {
          text: data.priority,
          value: data.priority,
        };
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ isEdit ? "Update" : "Add New" }} Ticket</h4>
        <hr />
        <div class="row">
          <Loader :loading="{ isLoading: isLoadingEdit }" />
          <!-- Basic Details -->
          <h4 class="card-title">Basic Details</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="domain">
              <span slot="label">
                Domain
                <span class="text-danger">*</span>
              </span>
              <Multiselect
                v-model="pbx_serve_form.domain_uuid"
                :options="domainListOptions"
                @close="handleDomainChange()"
                :show-labels="false"
                label="text"
                track-by="value"
                id="select-domain"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.domain_uuid.$error,
                }"
              />
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.domain_uuid.required">
                  Domain is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="caller_name">
              <span slot="label"> Caller Name </span>
              <b-form-input
                id="caller_name"
                type="text"
                autocomplete="off"
                v-model="pbx_serve_form.caller_name"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="email">
              <span slot="label"> Email</span>
              <b-form-input
                id="caller_email"
                type="email"
                autocomplete="off"
                v-model="pbx_serve_form.caller_email"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.caller_email.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.caller_email.email">
                  Enter valid email.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="caller_number">
              <span slot="label"> Call Back No</span>
              <b-form-input
                id="caller_number"
                type="number"
                autocomplete="off"
                v-model="pbx_serve_form.caller_number"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.caller_number.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.caller_number.minLength">
                  Number not be less than 10.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="is_email_notification">
              <span slot="label"> Send Email Notification</span>
              <div class="form-check form-switch form-switch-md mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_email_notification"
                  v-model="pbx_serve_form.is_email_notification"
                />
              </div>
            </b-form-group>
          </div>

          <!-- Ticket Details -->
          <h4 class="card-title">Ticket Details</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="ticket_title">
              <span slot="label">Title <span class="text-danger">*</span></span>
              <vue-typeahead-bootstrap
                v-model="pbx_serve_form.ticket_title"
                @hit="handleHit"
                :data="titleData"
                trackby="title"
                placeholder="Search title"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.ticket_title.$error,
                }"
              />
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.ticket_title.required"
                  >Title is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="priority">
              <span slot="label"
                >Priority <span class="text-danger">*</span></span
              >
              <Multiselect
                v-model="pbx_serve_form.priority"
                :options="priorityOptions"
                :show-labels="false"
                label="text"
                track-by="value"
                id="select-priority"
                :class="{
                  'is-invalid': submitted && $v.pbx_serve_form.priority.$error,
                }"
              />
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.priority.required"
                  >Priority is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="assign_to_user_uuid">
              <span slot="label"
                >Assigned To <span class="text-danger">*</span></span
              >
              <Multiselect
                v-model="pbx_serve_form.assign_to_user_uuid"
                :options="assignedToOptions"
                :show-labels="false"
                label="text"
                track-by="value"
                id="select-assigned-to"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.assign_to_user_uuid.$error,
                }"
              />
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.assign_to_user_uuid.required">
                  Assign to user name is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="description">
              <span slot="label">
                Description
                <span class="text-danger">*</span>
              </span>
              <textarea
                class="form-control"
                name="textarea"
                rows="3"
                v-model="pbx_serve_form.description"
                :class="{
                  'is-invalid':
                    submitted && $v.pbx_serve_form.description.$error,
                }"
              ></textarea>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_serve_form.description.required">
                  Description is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="attached_file">
              <span slot="label">Upload file</span>
              <input
                type="file"
                class="form-control"
                placeholder="Video File"
                name="attached_file"
                :src="pbx_serve_form.attached_file"
                @change="uploadFile($event)"
              />
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>

          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
